$(document).ready(function () {
    const shippingCosts = $("#order-form input[name=shipping_costs]");
    if (shippingCosts.length) {
        updateShippingCostsFieldBgColor();
        shippingCosts.on("change", function () {
            updateShippingCostsFieldBgColor();
        })
    }


});

/**
 * Change background of the shipping costs field when it"s equal to 0
 */
function updateShippingCostsFieldBgColor() {
    const shippingCosts = $("#order-form input[name=shipping_costs]");
    if (shippingCosts.val() > 0) {
        shippingCosts.removeClass("bg-warning");
    } else {
        shippingCosts.addClass("bg-warning");
    }
}
